// Copyright (c) 2017 Deere & Company

import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetInvoiceToComplete = () =>
    getDefaultState().invoiceToComplete;

const updateInvoiceToComplete = (state, action) =>
    Invoice.update(state, {
        $set: action.invoice
    });

const updateClaimsProcess = (state, action) =>
    Invoice.update(state, {
        claimsProcess: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updateMassProcess = (state, action) =>
    Invoice.update(state, {
        massProcess: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const actionTypes = {
    [actions.RESET_DEALER_INVOICE_INVOICE_TO_COMPLETE]: resetInvoiceToComplete,
    [actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE]: updateInvoiceToComplete,
    [actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_CLAIMS_PROCESS]: updateClaimsProcess,
    [actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_MASS_PROCESS]: updateMassProcess
};

export default (state = getDefaultState().invoiceToComplete, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/reducers/invoice-to-complete.js